<template>
  <section class="shopping-cart-resume">
    <div class="shopping-cart-resume__prices-wrapper">
      <div class="shopping-cart-resume__type">
        <Pill cart class="shopping-cart-resume__pill">
          {{ shoppingCart.length }} Item{{ shoppingCart.length > 1 ? 's' : '' }}
        </Pill>
        Total today {{ currencySymbol }}{{ total }}
        <span class="shopping-cart-resume__label shopping-cart-resume__taxes">
          {{ taxes > 0 ? '' : 'before tax' }}
        </span>
      </div>
    </div>
  </section>
</template>

<script>
import { priceDetailUpdates } from '@/helpers/mixins'
import Pill from '@/components/shared/Pill.vue'

export default {
  name: 'ShoppingCartResume',
  mixins: [priceDetailUpdates],
  components: {
    Pill,
  },
  watch: {
    paymentEntries: {
      deep: true,
      handler(paymentEntries) {
        const { country, zip } = paymentEntries
        this.recurlyPricing
          .address({
            country,
            postal_code: zip,
          })
          .catch(err => this.handleError(err))
          .done()
      },
    },
  },
}
</script>

<style lang="scss">
.shopping-cart-resume {
  font-family: var(--font-medium);
  color: var(--white);
  background: var(--mid-gray-translucid-gradient-three), var(--dark-brighter);
  border-radius: 20px;
  padding: 20px;
  white-space: nowrap;
  &__type {
    display: flex;
    align-items: baseline;
  }
  &__taxes {
    color: var(--light-blue-gray);
    font-size: rem(14px);
    font-style: italic;
    margin-left: 3px;
  }
  &__pill {
    margin-right: 10px;
  }
}
</style>
